export interface FeaturedTopic {
  id: string;
  title: string;
  subtitle: string;
  icon: string;
  color: string;
  articles: string[];
}

export const featuredTopics: FeaturedTopic[] = [
  {
    id: "ft1",
    title: "职场新人通关手册",
    subtitle: "从第一份简历到第一次晋升，陪你走好职场每一步",
    icon: "ri-rocket-line",
    color: "primary",
    articles: ["a1", "a7"],
  },
  {
    id: "ft2",
    title: "情感关系必修课",
    subtitle: "第一次心动、第一次约会、第一次见家长——温柔指南",
    icon: "ri-hearts-line",
    color: "accent",
    articles: ["a2", "a8"],
  },
  {
    id: "ft3",
    title: "独立生活成长营",
    subtitle: "从租房到做饭，从理财到自律，独立人生的第一步",
    icon: "ri-home-gear-line",
    color: "secondary",
    articles: ["a4", "a9"],
  },
];

export const testimonials = [
  {
    id: "t1",
    name: "小陈",
    role: "应届毕业生",
    content: "使用了面试完全攻略中的STAR法则来准备，第一次面试就拿到了心仪的Offer。感谢这个平台，让我在最紧张的时候找到了方向。",
    avatarSeq: "testimonial-01",
    avatarQuery: "A warm professional portrait of a young Chinese woman with confident smile, soft natural lighting, cream and warm beige background, editorial portrait photography with friendly and approachable atmosphere",
  },
  {
    id: "t2",
    name: "阿杰",
    role: "自由职业者",
    content: "独自旅行手册是我出发前反复阅读的文章。现在已经一个人走过了七个国家，每一个「第一次」都让我更了解自己。",
    avatarSeq: "testimonial-02",
    avatarQuery: "A warm casual portrait of a young Chinese man with relaxed smile, soft natural lighting, cream and warm beige background, editorial portrait photography with adventurous and friendly atmosphere",
  },
  {
    id: "t3",
    name: "琳琳",
    role: "大学生",
    content: "第一次上台演讲前，我把那篇公开演讲的文章从头到尾看了三遍。虽然还是紧张，但我做到了！那种成就感至今难忘。",
    avatarSeq: "testimonial-03",
    avatarQuery: "A warm portrait of a young Chinese student woman with bright smile, soft natural lighting, cream and warm beige background, editorial portrait photography with youthful and inspiring atmosphere",
  },
];